import { createFileRoute } from '@tanstack/react-router';
import { SystemMonitorLayout } from '@/pages/admin/system-monitor/layout';
import { systemMonitorSearchSchema } from '@/routes/-shared/systemMonitorSearchSchema';

export const Route = createFileRoute('/admin/_layout/system-monitor/_layout')({
  component: SystemMonitorLayout,
  validateSearch: systemMonitorSearchSchema,
});
